import React from "react";
import { connect } from "react-redux";
import LoginForm from "../components/auth/LoginForm";
import { Redirect } from "react-router";
import { LoginStatus } from "../constants/loginStatus";
export const Login = ({ status }) => {
	return (
		<div className='' id='login-form-container'>
			{status === LoginStatus.LOGIN_SUCCESS ? <Redirect to='/dashboard' /> : <LoginForm />}
		</div>
	);
};

const mapStateToProps = (state) => ({
	status: state.user.status,
});

export default connect(mapStateToProps, null)(Login);
